import SystemCheckLine2 from './system-check-line2.component.js'

export * from './system-check-line2.component.js'
export default SystemCheckLine2

SystemCheckLine2.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-check-line2': SystemCheckLine2
  }
}
